<template>
  <v-container>
    <v-row align="center" justify="center" class="my-6">
      <div>
        <img
          src="@/assets/billy_not_found.svg"
          width="200"
          class="mb-2">
      </div>
      <div class="text-center">
        <h1 class="display-1 font-weight-bold">Error {{status}}</h1>
        <p class="subtitle-1">{{message}}</p>
      </div>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'ErrorPage',
  props: {
    message: { type: String, required: true },
    status: { type: String, required: true },
  },
};
</script>
